import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';

import ReedemCode from '../components/ReedemCode';
import sharedContainer from './ReedemCodeSharedContainer';
import WithTimeWaitingList from '../../hoc/WithTimeWaitingList';
import { getNoExtrasForReserveNoPay } from '../../shops/selectors';
import WithApplePayQuery from '../../hoc/WithApplePayQuery';
import withRouteParameters from './withRouteParameters';

const mapStateToProps = (state, ownProps) => ({
  noExtrasForBookNoPay: getNoExtrasForReserveNoPay(state, ownProps.shopRoute),
});

export default compose(
  WithApplePayQuery,
  withRouteParameters,
  WithTimeWaitingList,
  connect(mapStateToProps, null),
  branch(
    props => props.timeWaitingList || (props.noExtrasForBookNoPay && !props.withApplePay),
    renderNothing,
  ),
  sharedContainer,
)(ReedemCode);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/ReedemCode.js